<template>
  <div id="app">
    <heading />
    <content-frame />
  </div>
</template>

<script>
import Heading from "./components/Header.vue";
import ContentFrame from "./components/Content.vue";
import { mapMutations } from "vuex";
import { vuexMutations } from "./store";

export default {
  name: "App",
  components: {
    Heading,
    ContentFrame
  },
  created() {
    this.updateViewport();
    window.addEventListener("scroll", this.updateViewport, { passive: true });
  },
  methods: {
    ...mapMutations({ updateViewport: vuexMutations.UPDATE_VIEWPORT_INFO })
  }
};
</script>
